import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=1467e914&scoped=true"
import script from "./Delivery.vue?vue&type=script&lang=js"
export * from "./Delivery.vue?vue&type=script&lang=js"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=1467e914&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1467e914",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1467e914')) {
      api.createRecord('1467e914', component.options)
    } else {
      api.reload('1467e914', component.options)
    }
    module.hot.accept("./Delivery.vue?vue&type=template&id=1467e914&scoped=true", function () {
      api.rerender('1467e914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OrderDetail/Delivery.vue"
export default component.exports